import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Table, Params, Actions, Menu } from 'nallian-table-builder-ui';
import { PageContent, PageTitle, Button, Link } from 'nallian-shared-ui/lib/components';
import HasRight from 'nallian-shared-ui/lib/layout/rights/HasRight';
import { ACTIONS, INFINITE_SCROLL, THEME_LOOKUPS_RESOURCE } from '../constants';
import NewThemeLookup from './NewThemeLookup';
import EditThemeLookup from './EditThemeLookup';
import apiRoutes from '../../../app/api/routes';

const MENU_RIGHTS = ['theme-lookups/update', 'theme-lookups/delete'];

const ThemeLookupsOverview = () => {
  const { t } = useTranslation();
  const { id, action } = useParams();

  return (
    <>
      <PageTitle>{t('themeLookups_plural')}</PageTitle>
      <PageContent>
        <HasRight right="theme-lookups/create">
          <NewThemeLookup open={!id && action === ACTIONS.ADD} />
          <Link to={`/theme-lookups/${ACTIONS.ADD}`}>
            <Button btnprimary icon="add" content={t('newThemeLookup')} />
          </Link>
        </HasRight>
        <HasRight right="theme-lookups/update">
          <EditThemeLookup open={id && action === ACTIONS.EDIT} />
        </HasRight>
        <EditThemeLookup open={id && action === ACTIONS.EDIT} />
        <Table
          infiniteScroll={INFINITE_SCROLL}
          resource={THEME_LOOKUPS_RESOURCE}
          url={apiRoutes.themeLookups()}
          pageSize={50}
          noUserSettings
        >
          <Actions.Link
            iconbutton
            hasRight="theme-lookups/update"
            width="2.5rem"
            icon="eye"
            align="center"
            url={`/theme-lookups/${ACTIONS.EDIT}/:id`}
          />
          <Params.String name="title" width="16rem" minWidth="16rem" grow noFilter />
          <Params.String name="host" width="16rem" minWidth="16rem" grow noFilter />
          <Params.String name="themeName" width="16rem" minWidth="16rem" grow noFilter />
          <Menu width="3.5rem" align="center" hasSomeRights={MENU_RIGHTS}>
            <Actions.Link
              label="edit"
              icon="edit"
              url={`/theme-lookups/${ACTIONS.EDIT}/:id`}
              hasRight="theme-lookups/update"
            />
            <Actions.Delete
              url={apiRoutes.themeLookups(':id')}
              label="removeThemeLookup"
              hasRight="theme-lookups/delete"
            />
          </Menu>
        </Table>
      </PageContent>
    </>
  );
};

ThemeLookupsOverview.propTypes = {};
ThemeLookupsOverview.defaultProps = {};

export default ThemeLookupsOverview;
